<template>
    <div class="password-toggle-wrap">
        <slot></slot>
        <svg
            class="password-toggle text-indigo-600"
            @click="toggleType"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            role="img"
            stroke="currentColor"
            stroke-width="1.7"
            aria-label="Icono para poder ver contraseña"
        >
            <path fill="none" stroke-linecap="round" stroke-linejoin="round" :d="svgPath"></path>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'PasswordToggle',
    data() {
        return {
            show: false,
        };
    },
    computed: {
        svgPath() {
            return this.show
                ? 'M3.98 8.223A10.477 10.477 0 0 0 1.934 12c1.292 4.338 5.31 7.5 10.066 7.5.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'
                : 'M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z';
        },
    },
    methods: {
        toggleType() {
            this.show = !this.show;
            this.$slots.default.forEach((vnode) => (vnode.elm.type = this.show ? 'text' : 'password'));
        },
    },
};
</script>

<style>
.password-toggle-wrap {
    position: relative;
}
.password-toggle {
    cursor: pointer;
    height: 56%;
    margin-right: 0.75rem;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
}
</style>
